import { render, staticRenderFns } from "./VersionInformationDialog.vue?vue&type=template&id=50f3f37a&scoped=true&"
import script from "./VersionInformationDialog.vue?vue&type=script&lang=ts&"
export * from "./VersionInformationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VersionInformationDialog.vue?vue&type=style&index=0&id=50f3f37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3f37a",
  null
  
)

export default component.exports